
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || window.AlpacaGiftCart.busy) return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');
        let added = false;
        try {
          const data = new FormData(this.form);
          const checkbox = this.form.querySelector('.alpaca-gift-box-checkbox');
          const variants = JSON.parse(this.querySelector('[data-alpaca-variant-labels]')?.textContent || '{}');
          const title = variants[data.get('id')] || this.dataset.alpacaProductTitle || '';
          const ids = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
          if (this.cart) this.cart.setActiveElement(document.activeElement);
          const response = await window.AlpacaGiftCart.add(data, checkbox, ids, title);
          added = true;
          if (!this.cart || response.needsReview) {
            window.location.assign(window.routes.cart_url);
            return;
          }
          const render = () => {
            try {
              this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: data.get('id') });
            } catch (error) {
              // The products are already added. Recover by showing the authoritative cart.
              window.location.assign(window.routes.cart_url);
            }
          };
          const modal = this.closest('quick-add-modal');
          if (modal) {
            document.body.addEventListener('modalClosed', render, { once: true });
            modal.hide(true);
          } else render();
        } catch (error) {
          if (added) window.location.assign(window.routes.cart_url);
          else {
            this.handleErrorMessage(error.message || 'Open your cart to check whether the items were added.');
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', message: error.message });
            if (error.uncertain) window.location.assign(window.routes.cart_url);
          }
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
